import notes from "./notes.component";

const notesModule = angular
  .module("app.components.notes", [])
  .component("notes", notes);

export default notesModule;



// WEBPACK FOOTER //
// ./src/components/notes/notes.module.js